import { UntypedFormControl }        from '@angular/forms';
import { WidgetLayout }       from '@cs/core';
import { ValidationResult }   from '@cs/core';
import { PropertyAnnotation } from '@cs/core';
import { Directive }          from '@angular/core';

@Directive({standalone: false})
export abstract class WidgetBase<T extends PropertyAnnotation<any>> {

	/**
	 * Indicates that the widget shows a disabled version of the widget instead of a Label Widget
	 */
	static hasReadOnlyState = false;

	propertyAnnotation: T;
	control: UntypedFormControl;
	errorMessages: ValidationResult[] = [];
	layout: WidgetLayout;
	id                                = '';
	name                              = '';
	widgetType;
	
	/**
	 * Reference to WidgetInfo for accessing dynamic properties like nestedVisibility
	 */
	widgetInfo?: any;
	
	/**
	 * Get nested visibility from widgetInfo (always reads the latest value)
	 */
	get nestedVisibility(): Map<string, boolean> | undefined {
		return this.widgetInfo?.nestedVisibility;
	}
}
